<template>
  <WelcomeHeader />

  <!-- Hero -->
  <section class="faq-hero">
    <div class="faq-hero-glow faq-hero-glow--teal"></div>
    <div class="faq-hero-glow faq-hero-glow--blue"></div>
    <div class="container faq-hero-inner">
      <span class="faq-badge">সহায়তা কেন্দ্র</span>
      <h1 class="faq-title">Frequently Asked <span class="faq-accent">Questions</span></h1>
      <p class="faq-sub">বিসিএস প্রস্তুতি সম্পর্কিত সাধারণ প্রশ্নের উত্তর</p>
      <div class="faq-hero-stats">
        <div class="fhs"><span class="fhs-n">২২+</span><span class="fhs-l">প্রশ্নের উত্তর</span></div>
        <div class="fhs-sep"></div>
        <div class="fhs"><span class="fhs-n">৩টি</span><span class="fhs-l">বিভাগ</span></div>
        <div class="fhs-sep"></div>
        <div class="fhs"><span class="fhs-n">৯ লাখ+</span><span class="fhs-l">সন্তুষ্ট শিক্ষার্থী</span></div>
      </div>
    </div>
  </section>

  <!-- FAQ Body -->
  <div class="faq-body">
    <div class="container faq-container">

      <div v-for="(section, si) in faqSections" :key="si" class="faq-section">
        <div class="faq-section-header">
          <span class="faq-section-icon">{{ section.icon }}</span>
          <div>
            <h2>{{ section.title }}</h2>
            <p>{{ section.desc }}</p>
          </div>
        </div>

        <div class="faq-list">
          <div v-for="(item, qi) in section.items" :key="qi"
               class="faq-item" :class="{ open: isOpen(si, qi) }">
            <button class="faq-question" @click="toggle(si, qi)">
              <span>{{ item.q }}</span>
              <span class="faq-chevron">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </button>
            <div class="faq-answer-wrap">
              <div class="faq-answer-inner" v-html="item.a"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact -->
      <div class="faq-contact">
        <div class="faq-contact-glow"></div>
        <div class="faq-contact-icon">💬</div>
        <h3>আরও প্রশ্ন আছে?</h3>
        <p>আমাদের সাপোর্ট টিম সাহায্য করতে সদা প্রস্তুত</p>
        <div class="faq-contact-actions">
          <a href="https://web.facebook.com/bcsprostutiApp" target="_blank" class="fc-btn fc-primary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"/></svg>
            Facebook Messenger
          </a>
          <a href="mailto:support@bcsprostuti.com" class="fc-btn fc-secondary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            support@bcsprostuti.com
          </a>
          <a href="tel:+8801894442944" class="fc-btn fc-secondary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.06 6.06l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            01894-442944
          </a>
        </div>
      </div>

    </div>
  </div>

  <WelcomeFooter />
</template>

<script>
import WelcomeHeader from "@/components/WelcomePages/WelcomeHeader.vue";
import WelcomeFooter from "@/components/WelcomePages/WelcomeFooter.vue";
import { ref, onMounted } from "vue";

export default {
  components: { WelcomeHeader, WelcomeFooter },
  setup() {
    const openItem = ref(null);

    const toggle = (si, qi) => {
      const key = `${si}-${qi}`;
      openItem.value = openItem.value === key ? null : key;
    };
    const isOpen = (si, qi) => openItem.value === `${si}-${qi}`;

    const faqSections = [
      {
        icon: '📚',
        title: 'প্রস্তুতি সংক্রান্ত',
        desc: 'বিসিএস প্রস্তুতি শুরু ও কৌশল নিয়ে সাধারণ প্রশ্নসমূহ',
        items: [
          {
            q: 'বিসিএস প্রস্তুতি অ্যাপটি কি? কাদের জন্য এই অ্যাপ?',
            a: `<p>বিসিএস সহ যে কোন ধরণের সরকারী চাকুরীর প্রস্তুতির জন্যই এই অ্যাপ। আপনার মোবাইলে যে কোন জায়গা থেকে লক্ষাধিক পরীক্ষার্থীদের সাথে বিভিন্ন রকম লাইভ পরীক্ষা, টপিক কিংবা বিষয়ভিত্তিক পরীক্ষা দিয়ে নিজেকে প্রতিনিয়ত যাচাই করার জন্যই এই প্ল্যাটফর্ম: <strong>বিসিএস প্রস্তুতি।</strong></p>`,
          },
          {
            q: 'আমি নতুন করে প্রস্তুতি শুরু করতে চাচ্ছি। কিভাবে শুরু করতে পারি?',
            a: `<p>প্রস্তুতির শুরুতেই দেখে নিন আমাদের <strong>বিষয়ভিত্তিক গাইডলাইন</strong> — বিসিএস ৩৫–৫০ পর্যন্ত টপিকভিত্তিক প্রশ্ন বিশ্লেষণ সহ।</p>
            <ul>
              <li>বিসিএস প্রিলিমিনারি সম্পূর্ণ সিলেবাস টপিক অনুসারে মার্ক ডিস্ট্রিবিউশন</li>
              <li>কোন কোন বই পড়বেন সেজন্য রেফারেন্স বুক</li>
              <li>টপিক অনুসারে বিগত বছরের প্রশ্ন বিশ্লেষণ</li>
              <li>কোন টপিকে বেশি গুরুত্ব দেবেন সেটার দিকনির্দেশনা</li>
            </ul>
            <p>তাছাড়া অ্যাপের রেগুলার ২টি কোর্স — <strong>বিসিএস প্রস্তুতি (১২০ দিন)</strong> বা <strong>বিসিএস প্রস্তুতি (৬ মাস)</strong> — এর যে কোন একটা কোর্স ভালো করে ফলো করুন।</p>`,
          },
          {
            q: 'আমি এখনও ছাত্র, কিভাবে বিসিএস প্রস্তুতি শুরু করব?',
            a: `<p>বিসিএস এখন অনেক বেশি প্রতিযোগিতাপূর্ণ। তাই আগে থেকেই প্রস্তুত হওয়া বিচক্ষণ সিদ্ধান্ত।</p>
            <p>এখন থেকে <strong>ম্যাথ আর ইংলিশ</strong> এর ওপর জোর দিন। রেগুলার বাংলা ও ইংরেজি পত্রিকা পড়ুন। মুক্তিযুদ্ধ নিয়ে উপন্যাস পড়ুন। রবীন্দ্রনাথ, শরৎচন্দ্র, সমরেশ মজুমদারের বই পড়ুন। ইউটিউবে ইংলিশ TED Talk শুনুন। নিয়মিত গণিত চর্চা রাখুন।</p>`,
          },
          {
            q: 'চাকরির পাশাপাশি কিভাবে পড়াশোনা করব?',
            a: `<p>ঠিক আপনাদের কথা চিন্তা করেই আমরা নিয়ে এসেছি <strong>'বিসিএস প্রস্তুতি (৬ মাস)'</strong> কোর্সটি। দৈনিক ২–৩ ঘণ্টাতেই শেষ করা যায় — এমনভাবেই তৈরি করা হয়েছে সম্পূর্ণ সিলেবাস এবং রুটিন। এই কোর্সটি ফলো করলেই চাকুরীর পাশাপাশি একটা ভালো প্রস্তুতি নিতে পারবেন।</p>`,
          },
          {
            q: 'বিসিএস প্রস্তুতি অ্যাপের কোন কোর্স আমার জন্য উপযোগী?',
            a: `<p>আপনি যদি <strong>একদম নতুন, চাকরিজীবী বা অনার্স ৩য়/ফাইনাল বর্ষের ছাত্র</strong> হন — তাহলে <strong>বিসিএস প্রস্তুতি ৬ মাসের</strong> কোর্সটি আপনার জন্য।</p>
            <p>হাতে যথেষ্ট সময় থাকলে <strong>বিসিএস প্রস্তুতি (১২০ দিন)</strong> কোর্সটি ফলো করুন।</p>
            <p>অন্তত একবার প্রিলিমিনারি দিয়েছেন বা সিলেবাস একবার শেষ করেছেন — তাদের জন্য <strong>বিসিএস প্রস্তুতি রিভিশন [পুরাতনদের]</strong> সবচেয়ে উপযোগী।</p>`,
          },
          {
            q: 'অনেকদিন ধরে চেষ্টা করছি, ভালো ফলাফল করতে পারছি না। কি করব?',
            a: `<p>প্রচুর পরিমাণে পড়াশোনা করার কোন বিকল্প নেই। সাথে বিকল্প নেই পরীক্ষা দেয়ার। যত বেশি পড়বেন, তত ভালো করবেন। যত বেশি পরীক্ষা দেবেন, তত উত্তীর্ণ হবার সম্ভাবনা বাড়বে।</p>
            <p>কোথায় কোথায় বেশি ভুল করেন সেগুলোর দিকে নজর দিন এবং সেগুলো নিয়ে কাজ করুন।</p>`,
          },
          {
            q: 'বিসিএস প্রস্তুতি অ্যাপ কিভাবে ব্যবহার করলে সবচেয়ে ভাল করতে পারব?',
            a: `<p>যেই টপিক পড়ছেন, সেটা পড়ার পর অ্যাপে ঢুকে <strong>টপিক-ভিত্তিক পরীক্ষা</strong> যত বেশি দিবেন তত উপকার পাবেন। পরীক্ষায় যা ভুল করছেন, সেগুলো <strong>মার্ক করে রাখুন</strong> এবং রিভিশন দিন। আর্কাইভ থেকে পুরাতন পরীক্ষাগুলো দিয়ে নিজেকে যাচাই করুন।</p>`,
          },
          {
            q: 'গণিতে দুর্বল, কিভাবে ভালো করতে পারি?',
            a: `<p>গণিতে দুর্বল হলে প্রথমে <strong>বেসিক ঠিক করুন</strong> — গণিতের বোর্ড বই (৬–১০ শ্রেণি) উদাহরণসহ সব অংক করে ফেলুন। এরপর অ্যাপে এসে <strong>টপিক ধরে ধরে</strong> ম্যাথ করুন অনুশীলনে গিয়ে। যেগুলো পারবেন না, ব্যাখ্যাগুলো ভালো করে পড়ুন। গণিত হচ্ছে প্র্যাকটিসের বিষয় — প্রচুর প্র্যাকটিস করুন।</p>`,
          },
          {
            q: 'ইংরেজিতে দুর্বল, কিভাবে ভালো করতে পারি?',
            a: `<p>ইংরেজিতে দুর্বল হলে কোনো একটা গ্রামার বইকে মেইন বই ধরে <strong>টপিক বাই টপিক</strong> শেষ করুন। সাথে প্রচুর অনুশীলন করুন। রেগুলার ইংরেজি লেখা পড়ুন ও লিখুন। YouTube-এ রেগুলার TED Talk শুনুন। সবচেয়ে ভালো হয় ইংরেজি বই পড়া শুরু করলে।</p>`,
          },
          {
            q: 'সাম্প্রতিক বিশ্ব নিয়ে কিভাবে প্রস্তুতি নেব?',
            a: `<p>বিসিএসে সাম্প্রতিক বিশ্ব থেকে খুব বেশি প্রশ্ন আসে না। যা আসে তার বেশিরভাগই টপিক রিলেটেড। তাই <strong>রেগুলার পত্রিকা পড়ার কোন বিকল্প নেই</strong>। এছাড়াও প্রতিমাসে কারেন্ট অ্যাফেয়ার্স পড়তে পারেন।</p>`,
          },
          {
            q: 'জব সলিউশন পড়লেই হয়ে যাবে, নাকি আরও কিছু পড়তে হবে?',
            a: `<p>আমাদের <strong>অনুশীলন সেকশন</strong> সব গুরুত্বপূর্ণ প্রশ্নের সমন্বয়ে সাজানো হয়েছে। প্রতিটি প্রশ্ন ব্যাখ্যাসহ পড়লে যে কোনো সরকারি চাকরির পরীক্ষার জন্য ভালো প্রিপারেশন হয়ে যাবে। এর পাশাপাশি বিষয়ভিত্তিক গাইডলাইন ফলো করে বই সিলেক্ট করে পড়লে প্রস্তুতি আরও ভালো হবে।</p>`,
          },
        ],
      },
      {
        icon: '📱',
        title: 'অ্যাপ ব্যবহার সংক্রান্ত',
        desc: 'অ্যাপ ব্যবহার ও ফিচার সম্পর্কিত প্রশ্নসমূহ',
        items: [
          {
            q: 'আমার প্রস্তুতি ভালো, এখন কিভাবে এগালে ভালো হবে?',
            a: `<p>অ্যাপে প্রচুর পরিমাণে পরীক্ষা দিতে থাকুন। যত বেশি সম্ভব এবং যত ধরনের পরীক্ষা আছে সব দিন। প্রতিনিয়ত যে ভুলগুলো করছেন সেগুলো ফোকাস করে কাজ করুন। সাথে উপযোগী একটি কোর্স ভালো করে ফলো করুন।</p>`,
          },
          {
            q: 'বিসিএস এর জন্য কি পড়ব, কোথায় থেকে পড়ব?',
            a: `<p>আমাদের ওয়েবসাইটে <strong>বিষয়ভিত্তিক গাইডলাইন</strong> দেখুন — বাংলা, ইংরেজি ও বাংলাদেশ বিষয়াবলির সম্পূর্ণ হিটম্যাপ বিশ্লেষণ সহ। অ্যাপের <strong>লেকচার অ্যান্ড নোটস</strong> সেকশনেও গাইডলাইন পাবেন।</p>`,
          },
          {
            q: 'বিসিএস এর পাশাপাশি ব্যাংক প্রস্তুতি কিভাবে নিতে পারি?',
            a: `<p>অ্যাপ থেকে <strong>'ব্যাংক প্রশ্ন-ব্যাংক'</strong> দেখে ব্যাংক এক্সামের প্রশ্নের ধরন বুঝুন। ডেডিকেটেডভাবে ব্যাংক প্রস্তুতি নিতে <strong>ব্যাংক প্রস্তুতি (৮০ দিন)</strong> কোর্সটি ফলো করুন। পাশাপাশি বিসিএস কোর্স ফলো করলেই হয়ে যাবে।</p>`,
          },
        ],
      },
      {
        icon: '💳',
        title: 'প্যাকেজ ও পেমেন্ট',
        desc: 'প্যাকেজ কেনা, পেমেন্ট ও অ্যাকাউন্ট সংক্রান্ত প্রশ্নসমূহ',
        items: [
          {
            q: 'প্যাকেজ চালু করলে কি কি সুবিধা পাবো?',
            a: `<p>প্যাকেজ কিনলে আমাদের <strong>চলমান সব কোর্সের এক্সেস</strong> পাবেন এবং সব এক্সাম অ্যাটেন্ড করতে পারবেন। মিস করা এক্সাম আর্কাইভ থেকে দিতে পারবেন। অনুশীলন, টপিক-ভিত্তিক পরীক্ষা, প্রশ্ন ব্যাংক, কুইজ এবং লেকচার — সবকিছুতে এক্সেস পাবেন।</p>`,
          },
          {
            q: '১ বছরের প্যাকেজে কি কি থাকছে?',
            a: `<p>১ বছরের জন্য সম্পূর্ণ অ্যাপের এক্সেস পাবেন। চলমান সব কোর্স — <strong>বিসিএস প্রস্তুতি (১২০ দিন), বিসিএস প্রস্তুতি (৬ মাস)</strong>, আর্কাইভে থাকা কোর্স এবং ভবিষ্যতে যত কোর্স যুক্ত হবে সবের ফুল এক্সেস। বিষয়ভিত্তিক পরীক্ষা, অনুশীলন, প্রশ্ন ব্যাংক, কুইজ এবং লেকচার নোটস সবকিছু।</p>`,
          },
          {
            q: 'বিসিএস প্রস্তুতি অ্যাপে কিভাবে প্যাকেজ চালু করব?',
            a: `<p>অ্যাপে প্রবেশ করে নিচের দিকে <strong>"আরও"</strong> সেকশনে গিয়ে <strong>"প্যাকেজ"</strong> অপশন থেকে যে কোন প্যাকেজে ক্লিক করলেই পেমেন্টের অপশন পেয়ে যাবেন। পেমেন্ট করে সাবস্ক্রাইব করে নিন।</p>
            <p>ওয়েবসাইট থেকেও সরাসরি প্যাকেজ কিনতে পারবেন: <a href="/packages">প্যাকেজ দেখুন →</a></p>`,
          },
          {
            q: 'প্রোমো কোড কিভাবে ব্যবহার করব?',
            a: `<p>অ্যাপের <strong>"প্যাকেজ"</strong> অপশন থেকে পছন্দের প্যাকেজে ক্লিক করুন। নিচে <strong>"প্রোমোকোড"</strong> লেখা আছে — সেখানে কোডটি টাইপ করে <strong>"অ্যাড"</strong> বাটনে ক্লিক করুন। ডিসকাউন্ট প্রাইস দেখে <strong>"এগিয়ে যান"</strong> বাটনে ক্লিক করে পেমেন্ট সম্পন্ন করুন।</p>`,
          },
          {
            q: 'বিকাশ বা নগদ একাউন্ট নেই। প্যাকেজ এক্টিভ করতে পারব?',
            a: `<p>অন্য কারো বিকাশ বা নগদ একাউন্ট ব্যবহার করে প্যাকেজ এক্টিভ করতে পারবেন। পেমেন্টের পর অ্যাপ থেকেই অটোমেটিক এক্টিভ হয়ে যাবে।</p>
            <p>অথবা মার্চেন্ট নম্বরে পেমেন্ট করুন:</p>
            <p><strong>Bkash/Nagad:</strong> 01313899797 [merchant]</p>
            <p>পেমেন্টের পর প্যাকেজের নাম, Transaction ID এবং User ID আমাদের ফেসবুক পেজের ইনবক্সে বা WhatsApp-এ দিলেই প্যাকেজ একটিভ করে দেয়া হবে।</p>`,
          },
          {
            q: 'আগে প্যাকেজ কেনা ছিল, কিন্তু এখন দেখাচ্ছে প্যাকেজ চালু নেই। সমাধান কি?',
            a: `<p>এর মানে আপনি অন্য কোনো আইডি দিয়ে লগইন করেছেন। অ্যাপে প্রবেশ করে <strong>প্রোফাইলে</strong> গিয়ে উপরে ডান পাশের কর্নারে প্রোফাইল আইকনে ক্লিক করুন — আপনার সম্ভাব্য সকল আইডি দেখতে পাবেন।</p>
            <p>সেখান থেকে আগের আইডি বের করে সেটা দিয়ে লগইন করলেই আগের সবকিছু ফিরে পাবেন।</p>`,
          },
          {
            q: 'প্যাকেজ একটিভ থাকতে আবার প্যাকেজ কিনলে কি হবে?',
            a: `<p>আগের প্যাকেজের সাথে নতুন প্যাকেজটি <strong>যোগ</strong> হয়ে যাবে। অর্থাৎ আগের প্যাকেজ মেয়াদমতো শেষ হবে, এরপর নতুন প্যাকেজের মেয়াদ শুরু হবে।</p>`,
          },
          {
            q: 'প্যাকেজ কেনা ছিল, কিন্তু একাউন্টের সব তথ্য ভুলে গেছি। কি করব?',
            a: `<p>অ্যাপ ইনস্টল করে <strong>Facebook বা Google</strong> দিয়ে সাইন ইন করুন। এরপর প্রোফাইলে গিয়ে উপরে ডান কর্নারের আইকনে ক্লিক করলে সম্ভাব্য সকল আইডি দেখতে পাবেন।</p>
            <p>যে আইডিতে প্যাকেজ চালু ছিল সেটা দিয়ে সাইন ইন করলেই সব ফিরে পাবেন। পাসওয়ার্ড ভুলে গেলে <strong>Forgot Password</strong> থেকে রিসেট করে নিন।</p>
            <p>যে কোনো সহায়তায়: <a href="https://web.facebook.com/bcsprostutiApp" target="_blank">Facebook Messenger</a> | <a href="mailto:support@bcsprostuti.com">support@bcsprostuti.com</a></p>`,
          },
        ],
      },
    ];

    onMounted(() => {
      window.scrollTo(0, 0);
      document.title = 'FAQ — বিসিএস প্রস্তুতি';
    });

    return { faqSections, toggle, isOpen };
  }
};
</script>

<style scoped>
* { box-sizing: border-box; }

/* Prevent scrollbar width shift */
:global(html) { scrollbar-gutter: stable; }

/* ── Hero ── */
.faq-hero {
  position: relative; overflow: hidden;
  background: linear-gradient(140deg, #191B47 0%, #0d0f2e 60%, #071833 100%);
  padding: 80px 0 68px;
}
.faq-hero-glow {
  position: absolute; border-radius: 50%; pointer-events: none;
}
.faq-hero-glow--teal {
  top: -15%; left: -8%;
  width: 55vw; height: 55vw;
  background: radial-gradient(circle, rgba(71,199,197,0.13) 0%, transparent 70%);
  animation: glow-pulse 7s ease-in-out infinite;
}
.faq-hero-glow--blue {
  bottom: -20%; right: -5%;
  width: 45vw; height: 45vw;
  background: radial-gradient(circle, rgba(0,149,255,0.11) 0%, transparent 70%);
  animation: glow-pulse 7s ease-in-out infinite reverse;
}
@keyframes glow-pulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50%       { transform: scale(1.08); opacity: 0.7; }
}

.faq-hero-inner { position: relative; text-align: left; }

.faq-badge {
  display: inline-block; font-size: 0.72rem; font-weight: 700;
  letter-spacing: 0.07em; text-transform: uppercase;
  color: #F59E0B; background: rgba(245,158,11,0.15);
  border: 1px solid rgba(245,158,11,0.35);
  padding: 5px 16px; border-radius: 999px; margin-bottom: 18px;
}
.faq-title {
  font-size: clamp(1.8rem, 4vw, 2.8rem); font-weight: 900;
  color: #fff; line-height: 1.25; margin-bottom: 14px;
}
.faq-accent { color: #F59E0B; }
.faq-sub { font-size: 1rem; color: #94a3b8; margin-bottom: 40px; }

.faq-hero-stats {
  display: inline-flex; align-items: center;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 16px; padding: 16px 24px;
  flex-wrap: wrap; justify-content: center; gap: 0;
  backdrop-filter: blur(8px);
}
.fhs { text-align: center; padding: 0 24px; }
.fhs-n { display: block; font-size: 1.5rem; font-weight: 800; color: #F59E0B; line-height: 1; }
.fhs-l { display: block; font-size: 0.72rem; color: #94a3b8; margin-top: 5px; }
.fhs-sep { width: 1px; height: 38px; background: rgba(255,255,255,0.12); }

/* ── Body ── */
.faq-body { background: #f1f5f9; padding: 60px 0 88px; text-align: left; }
.faq-container { max-width: 820px; text-align: left; }

/* ── Section ── */
.faq-section { margin-bottom: 52px; text-align: left; }
.faq-section-header {
  display: flex; align-items: flex-start; gap: 16px;
  margin-bottom: 20px; padding-bottom: 18px;
  border-bottom: 2px solid #e2e8f0;
  text-align: left;
}
.faq-section-icon {
  font-size: 1.8rem; line-height: 1; flex-shrink: 0; margin-top: 2px;
  width: 48px; height: 48px;
  background: linear-gradient(135deg, rgba(25,27,71,0.08), rgba(0,149,255,0.08));
  border: 1px solid rgba(25,27,71,0.1);
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
}
.faq-section-header h2 {
  font-size: 1.15rem; font-weight: 800; color: #191B47; margin: 0 0 4px 0; text-align: left;
}
.faq-section-header p { font-size: 0.82rem; color: #64748b; margin: 0; text-align: left; }

/* ── Accordion ── */
.faq-list {
  display: flex; flex-direction: column; gap: 10px;
  width: 100%;
}

.faq-item {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  width: 100%;
  min-width: 0;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.faq-item:hover {
  box-shadow: 0 4px 20px rgba(25,27,71,0.07);
}
.faq-item.open {
  border-color: #191B47;
  box-shadow: 0 6px 24px rgba(25,27,71,0.1);
}

.faq-question {
  width: 100%;
  min-width: 0;
  display: flex; align-items: center; justify-content: space-between;
  gap: 16px; padding: 20px 22px;
  background: none; border: none; cursor: pointer;
  font-size: 0.95rem; font-weight: 600; color: #1e293b;
  text-align: left; line-height: 1.55;
  transition: color 0.18s;
}
.faq-question span:first-child {
  flex: 1;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
}
.faq-item.open .faq-question { color: #191B47; }
.faq-question:hover { color: #191B47; }

.faq-chevron {
  flex-shrink: 0; color: #94a3b8;
  width: 28px; height: 28px;
  background: #f1f5f9; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  transition: transform 0.28s cubic-bezier(0.34, 1.56, 0.64, 1), background 0.2s, color 0.2s;
}
.faq-item.open .faq-chevron {
  transform: rotate(180deg);
  background: #191B47;
  color: #fff;
}

/* Grid-based accordion — zero width impact */
.faq-answer-wrap {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.32s ease;
  border-top: 0px solid transparent;
}
.faq-item.open .faq-answer-wrap {
  grid-template-rows: 1fr;
  border-top-color: #f1f5f9;
}

.faq-answer-inner {
  overflow: hidden;
  min-height: 0;
  padding: 0 22px;
  font-size: 0.88rem; color: #475569; line-height: 1.8;
  overflow-wrap: break-word;
  word-break: break-word;
  text-align: left;
  transition: padding 0.32s ease;
}
.faq-item.open .faq-answer-inner {
  padding: 18px 22px 22px;
}
.faq-answer-inner p { margin: 0 0 10px 0; }
.faq-answer-inner p:last-child { margin-bottom: 0; }
.faq-answer-inner ul { padding-left: 20px; margin: 8px 0; }
.faq-answer-inner li { margin-bottom: 6px; }
.faq-answer-inner strong { color: #1e293b; }
.faq-answer-inner a { color: #0095ff; font-weight: 600; text-decoration: underline; }
.faq-answer-inner a:hover { color: #191B47; }

/* ── Contact ── */
.faq-contact {
  position: relative; overflow: hidden;
  background: linear-gradient(135deg, #191B47 0%, #0d0f2e 50%, #1a2d6b 100%);
  border-radius: 20px; padding: 52px 40px; text-align: left; color: #fff;
  margin-top: 8px;
  box-shadow: 0 20px 60px rgba(25,27,71,0.25);
}
.faq-contact-glow {
  position: absolute; top: -30%; left: 50%; transform: translateX(-50%);
  width: 60%; height: 60%;
  background: radial-gradient(circle, rgba(71,199,197,0.15) 0%, transparent 70%);
  pointer-events: none;
}
.faq-contact-icon { font-size: 2.6rem; margin-bottom: 16px; }
.faq-contact h3 { font-size: 1.4rem; font-weight: 800; margin: 0 0 10px 0; }
.faq-contact p { color: #94a3b8; font-size: 0.92rem; margin: 0 0 32px 0; }
.faq-contact-actions { display: flex; justify-content: flex-start; flex-wrap: wrap; gap: 12px; }

.fc-btn {
  display: inline-flex; align-items: center; gap: 8px;
  font-size: 0.85rem; font-weight: 700; border-radius: 12px;
  padding: 12px 22px; text-decoration: none; transition: all 0.2s;
}
.fc-primary {
  background: #F59E0B; color: #1a1a1a;
  box-shadow: 0 4px 14px rgba(245,158,11,0.35);
}
.fc-primary:hover { background: #D97706; transform: translateY(-2px); box-shadow: 0 8px 20px rgba(245,158,11,0.4); }
.fc-secondary {
  background: rgba(255,255,255,0.08); color: #fff;
  border: 1px solid rgba(255,255,255,0.18);
}
.fc-secondary:hover { background: rgba(255,255,255,0.15); transform: translateY(-2px); }

@media(max-width: 600px) {
  .faq-hero { padding: 56px 0 48px; }
  .faq-contact { padding: 36px 24px; }
  .faq-question { font-size: 0.88rem; padding: 16px 18px; }
  .faq-answer-inner { padding: 14px 18px; }
  .fhs { padding: 0 16px; }
}
</style>
